import { ref } from 'vue'

/**
 * 全局"登录 / 免费开通"弹窗状态（侧栏底部登录栏 + 内容区欢迎门共用）。
 * 模块级 ref → 所有调用方共享同一份。
 */
export type AuthModalMode = 'login' | 'free'

const open = ref(false)
const initialMode = ref<AuthModalMode>('login')

export function useAuthModal() {
  return {
    open,
    initialMode,
    openAuth(mode: AuthModalMode = 'login') {
      initialMode.value = mode
      open.value = true
    },
    closeAuth() {
      open.value = false
    }
  }
}
